import SectionHead from "./SectionHead";
import { channels } from "@/mocks/homeData";

function scrollToSubmit() {
  document.getElementById("submit")?.scrollIntoView({ behavior: "smooth", block: "start" });
}

const tagColor: Record<string, string> = {
  HOT: "bg-primary-500 text-white",
  HIGH: "bg-foreground-950 text-background-50",
  NEW: "bg-accent-500 text-foreground-950",
  LIVE: "bg-accent-600 text-background-50",
};

export default function Channels() {
  return (
    <section id="topics" className="bg-background-50 py-16 md:py-24" aria-label="投稿频道">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <SectionHead
          eyebrow="投稿频道"
          title="选个频道，精准吃瓜"
          desc="校园、职场、追星、邻里、恋爱、社会六大频道任你选，选对频道你的爆料会被更懂的人看见。"
        />

        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {channels.map((ch) => (
            <article
              key={ch.name}
              className="group relative flex flex-col overflow-hidden rounded-2xl bg-background-100 p-6 transition-all hover:-translate-y-1"
            >
              <span className="absolute inset-x-0 top-0 h-1.5 bg-gradient-to-r from-primary-500 to-accent-500 opacity-0 transition-opacity group-hover:opacity-100" aria-hidden="true"></span>
              <div className="flex items-start justify-between">
                <span className="flex h-14 w-14 items-center justify-center rounded-xl bg-background-50 text-primary-600 ring-1 ring-background-200">
                  <i className={`${ch.icon} text-2xl`} aria-hidden="true"></i>
                </span>
                <span className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-bold ${tagColor[ch.tag] || "bg-secondary-100 text-secondary-900"}`}>
                  {ch.tag}
                </span>
              </div>
              <h3 className="font-serifsc mt-5 text-xl font-bold text-foreground-950">{ch.name}</h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{ch.desc}</p>
              <div className="mt-5 flex items-center justify-between border-t border-background-200 pt-4">
                <span className="text-xs text-foreground-500">
                  <i className="ri-eye-line mr-1" aria-hidden="true"></i>
                  {ch.count} 人围观
                </span>
                <button
                  type="button"
                  onClick={scrollToSubmit}
                  className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-foreground-950 px-4 py-2 text-xs font-semibold text-background-50 transition-colors hover:bg-primary-500"
                >
                  去投稿 <i className="ri-arrow-right-line text-sm" aria-hidden="true"></i>
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}